module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-114x114.5e9483c0476e069c32f882e9f4d7ab17.png";